<i18n>
en:
  complete: "Cancel completed."
ja:
  complete: "キャンセルが完了しました。"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      v-row
        v-col.mb-12.pb-12(cols="12" align="center")
          v-alert(dense outlined prominent type="success" border="bottom")
            div(v-html="$t('complete')")
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
</style>
